export function isAdmin(user) {
  if (!user) return false;
  const permiso = user.permiso ?? user?.usuario?.permiso;
  if (!permiso) return false;
  return String(permiso).toLowerCase() === 'admin';
}